export const Firebase_Config = {
  apiKey: "AIzaSyAFtdJjtaN8delvbrQBH4LnhHovqYVlJz4",
  authDomain: "h8live-carti.firebaseapp.com",
  databaseURL:
    "https://h8live-carti-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "h8live-carti",
  storageBucket: "h8live-carti.firebasestorage.app",
  messagingSenderId: "977269288387",
  appId: "1:977269288387:web:6bbd403353d121269da176",
};
// export const API = "http://localhost:8213/";
export const API = "https://api.quiz.h8live.com/";
export const globalKey = "CMHO"; //Nom de l'évenement (pour ne pas changer la BDD)
